<div class="formQuestion" [attr.data-question-id]="questionId">
  <div class="container">
    @if (name || tooltip) {
      <h2 class="content-card__header">
        @if (name) {
          <span [innerHTML]="name | safeHtml"></span>
        }
        @if (tooltip) {
          <mat-icon class="icon-md">info</mat-icon>
        }
      </h2>
    }

    @if (tooltip) {
      <alert #alert class="info" [message]="tooltip" alertType="info">
      </alert>
    }

    <ng-content></ng-content>
  </div>
</div>